import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AlertaEntity } from '../models/alertas.model';
import { AsistenciaRepository } from '../ports/asistencia.repository';
import { TiempoRealPort } from '../ports/tiempo-real.port';

@Injectable({ providedIn: 'root' })
export class BroadcastTiempoRealAdapter extends TiempoRealPort {
  private readonly repo = inject(AsistenciaRepository);

  alertasNuevas(destinatarioId: string): Observable<AlertaEntity[]> {
    return this.repo
      .observarAlertasDe(destinatarioId)
      .pipe(map(lista => lista.filter(a => a.estado === 'NUEVA' && a.visiblePanel)));
  }
}
